import React from 'react';
import { CircularProgress, Box } from '@material-ui/core';

export default function CentredCircularProgress() {
    return (
        <Box width="100%" height="100%" display="flex" justifyContent="center" alignContent="center" flexWrap="wrap">
            <CircularProgress />
      </Box>
    );
}